import script from "./HeaderMobile.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderMobile.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderMobile.vue?vue&type=style&index=0&id=01f7dd79&lang=scss"

const __exports__ = script;

export default __exports__